import React from 'react'
import { Table, Text } from '@mantine/core'
import { useTheme } from '../../../components/ThemeProvider'
import { useViewMode } from '../ViewModeProvider'
import PageEmpty from '../../../components/PageEmpty'
import RelatedCasesStatisticsChart from './RelatedCasesStatisticsChart'

interface RelatedCasesStatisticsProps {
  data: any
}

export default function RelatedCasesStatistics({ data }: RelatedCasesStatisticsProps) {
  const theme = useTheme()
  const { viewMode } = useViewMode()
  const civilCount = (data?.court_case_info?.civil ?? []).length
  const criminalCount = (data?.court_case_info?.criminal ?? []).length
  const otherCount = (data?.court_case_info?.other ?? []).length
  const total = civilCount + criminalCount + otherCount

  if (total === 0) {
    return (
      <div className="mt-2">
        <Text size="sm" fw={600} style={{ color: theme.accentTextColor }}>
          关联案件统计
        </Text>
        <PageEmpty />
      </div>
    )
  }

  const rows = [
    { label: '民事案件', count: civilCount },
    { label: '刑事案件', count: criminalCount },
    { label: '其他案件', count: otherCount },
  ]

  return (
    <div className="mt-2">
      <Text size="sm" fw={600} style={{ color: theme.accentTextColor }}>
        关联案件统计
      </Text>
      {viewMode === 'table' ? (
        <Table
          highlightOnHover
          withColumnBorders={false}
          verticalSpacing="sm"
          className="mt-3"
          styles={{
            th: {
              backgroundColor: theme.surfaceMutedColor,
              color: theme.accentTextColor,
            },
            table: {
              fontSize: '13px',
            },
          }}
        >
          <Table.Thead>
            <Table.Tr>
              <Table.Th>案件类型</Table.Th>
              <Table.Th>数量</Table.Th>
              <Table.Th>占比</Table.Th>
            </Table.Tr>
          </Table.Thead>
          <Table.Tbody>
            {rows.map((row) => (
              <Table.Tr key={row.label}>
                <Table.Td>{row.label}</Table.Td>
                <Table.Td>{row.count}</Table.Td>
                <Table.Td>{total === 0 ? '—' : `${Math.round((row.count / total) * 100)}%`}</Table.Td>
              </Table.Tr>
            ))}
          </Table.Tbody>
        </Table>
      ) : (
        <div className="mt-3">
          <RelatedCasesStatisticsChart data={data} />
        </div>
      )}
    </div>
  )
}
